import axios from 'axios';
import { baseUrl } from './constants';
import { toast } from 'react-toastify';

const mapTypetoEndPoint = (type) => {
  const types = {
    // 'country':'countries',
    'faq': 'faq',
  };
  return types[type] || type;
};

const DeleteObject = async (type, id, reload) => {
  try {
    const authTokens = JSON.parse(localStorage.getItem('tokens'));
    if (!authTokens || !authTokens.token) {
      throw new Error('Authentication token not found');
    }

    const payload = {
      headers: {
        Authorization: `${authTokens.token}`,
        'Content-Type': 'application/json'
      }
    };

    const response = await axios.delete(
      `${baseUrl}/${mapTypetoEndPoint(type)}/${id}`,
      payload
    );

    if (response.status === 200 || (response.data?.data?.status === 200)) {
      toast.success(response.data.message);
      if (typeof reload === 'function') {
        reload();
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || error.message || 'An error occurred');
  }
};

export default DeleteObject;